export const BEHAVIOR_STORAGE_KEY = 'fnd_survey_behavior'
